import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// project-imports
import { useUserContext } from "../../context/user_context";
import RegisterFormStencil from "./RegisterFormStencil";
import { Link, useNavigate, useParams } from "react-router-dom";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import { isBlockedDomain, toggle_password } from "../../utils";
import { GoogleAnalyticsEnum, pageView, triggerFunction } from "../../utils/google-analytics";
import Spinner from '../spinner-component/SpinnerOne';

// reading env variable start here
const INVALID_PASSWORD_ERROR_MESSAGE = process.env.REACT_APP_INVALID_PASSWORD_ERROR_MESSAGE;
const PASSWORD_ERROR_MESSAGE = process.env.REACT_APP_PASSWORD_ERROR_MESSAGE;
const CONFIRM_PASSWORD_ERROR_MESSAGE = process.env.REACT_APP_CONFIRM_PASSWORD_ERROR_MESSAGE;
// reading env variable end here

const ResetPasswordForm = ({ formStyle }) => {

    const navigate = useNavigate();

    // Extracting methods and variables from context
    const { handleResetPass, isLoading } = useUserContext();

    // Reading data from store
    const { loginData } = useSelector((item) => item.user);

    const { token } = useParams();

    // State variables
    const [stencilLoading, setStencilLoading] = useState(true);
    const [resetPasswordForm, setResetPasswordForm] = useState({
        password: null,
        confirmPassword: null,
    });
    const [inputValidationErrors, setInputValidationErrors] = useState({
        passwordError: "",
        confirmPassword: "",
    });

    // Constant variable
    const patterns = {
        password:
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=^[^@$!%*?&]*[@$!%*?&][^@$!%*?&]*$)[A-Za-z\d@$!%*?&]{8,16}$/,
        confirmPassword:
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=^[^@$!%*?&]*[@$!%*?&][^@$!%*?&]*$)[A-Za-z\d@$!%*?&]{8,16}$/,
    };

    setTimeout(() => {
        setStencilLoading(false);
    }, 1000);

    // Constant functions
    const handleChange = (e) => {
        try {
            let name = e.target.name;
            let value = e.target.value;
            let member = resetPasswordForm;
            if (name === "password") {
                member.password = value;
            } else if (name === "confirmPassword") {
                member.confirmPassword = value;
            }
            setInputValidationErrors((prev) => ({ ...prev, ...validationInput(member, name) }));
            setResetPasswordForm(member);
        } catch (error) {
            console.log("89 : RegisterForm : Error while changing input :", error && JSON.stringify(error));
            throw error;
        }
    };

    const validationInput = (member, name) => {
        try {
            let validationState = {};

            if (name === "password" || name === "all") {
                if (member && (!member.password || (member.password && !member.password.length))) {
                    validationState.passwordError = "Password is required";
                } else if (member.password && member.password.length && patterns["password"] && !(patterns["password"].test(member.password))) {
                    validationState.passwordError = PASSWORD_ERROR_MESSAGE;
                } else if (member.password && member.password.length && isBlockedDomain(member.password)) {
                    validationState.passwordError = INVALID_PASSWORD_ERROR_MESSAGE;
                } else {
                    validationState.passwordError = "";
                }
            }

            if (name === "confirmPassword" || name === "all") {
                if (member && (!member.confirmPassword || (member.confirmPassword && !member.confirmPassword.length))) {
                    validationState.confirmPassword = "Confirm Password is required";
                } else if (member.confirmPassword && member.confirmPassword.length && patterns["confirmPassword"] && !(patterns["confirmPassword"].test(member.confirmPassword))) {
                    validationState.confirmPassword = PASSWORD_ERROR_MESSAGE;
                } else if (member.confirmPassword && member.confirmPassword.length && !(member.confirmPassword === member.password)) {
                    validationState.confirmPassword = CONFIRM_PASSWORD_ERROR_MESSAGE;
                } else if (member.confirmPassword && member.confirmPassword.length && isBlockedDomain(member.confirmPassword)) {
                    validationState.confirmPassword = INVALID_PASSWORD_ERROR_MESSAGE;
                } else {
                    validationState.confirmPassword = "";
                }
            }

            setInputValidationErrors(validationState);
            return validationState;
        } catch (error) {
            console.log("163 : RegisterForm : Error while adding validation :", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleResetPassForm = async () => {
        try {
            let formIsValid = true;
            const validationErrros = validationInput(resetPasswordForm, "all");

            if (validationErrros.password || validationErrros.confirmPassword) {
                formIsValid = false;
            }
            if (formIsValid) {
                const body = {
                    token: token,
                    newPassword: resetPasswordForm.password
                }
                const res = await handleResetPass(body);
                triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.REGISTER_SUBMIT_BUTTON);
                if (res) {
                    navigate('/login', { replace: true });
                }
            }
        } catch (error) {
            console.log("187 : RegisterForm : Error while submit details => ", error && JSON.stringify(error));
            throw error;
        }
    };

    useEffect(() => {
        if (loginData && loginData?.token && loginData?.token.length) {
            navigate('/', { replace: true });
        }
    }, [loginData]);

    return (
        <>
            {pageView(window.location.pathname, GoogleAnalyticsEnum.LSA_REGISTER_FORM_VIEWED)}
            {isLoading && <Spinner />}
            <SEO title="Longswitch Academy Reset Password Form" url="https://longswitchacademy.com/reset-password" />
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title="Reset Password"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Reset Password"
                />
                <div className="login-register-page-wrapper edu-section-gapBottom bg-color-white">
                    <div className="container checkout-page-style">
                        <div className="row g-5">
                            <div className="col-lg-6 mx-auto">
                                {stencilLoading ? <RegisterFormStencil /> :
                                    <div className="register-form-box">
                                        <h3 className="text-center mb-0">Change Your Password</h3>
                                        <p className="text-center mb-30">Let's create new password for your account.</p>
                                        <div className={`${formStyle}`}>
                                            <div className="input-box mb--30">
                                                <label className="mb-2">
                                                    New Password
                                                </label>
                                                <input
                                                    type="password"
                                                    id="password"
                                                    disabled={isLoading}
                                                    placeholder="New Password   e.g Shubham@123"
                                                    value={resetPasswordForm?.password || ""}
                                                    name="password"
                                                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=^[^@$!%*?&]*[@$!%*?&][^@$!%*?&]*$)[A-Za-z\d@$!%*?&]{8,16}$"
                                                    autoComplete="false"
                                                    title="Please Enter The valid Password"
                                                    onChange={handleChange}
                                                />
                                                {inputValidationErrors && inputValidationErrors.passwordError &&
                                                    <div className="invalid-data">{inputValidationErrors.passwordError}</div>
                                                }
                                            </div>
                                            <div className="input-box mb--30">
                                                <label className="mb-2">
                                                    Confirm New Password
                                                </label>
                                                <input
                                                    type="password"
                                                    disabled={isLoading}
                                                    placeholder="Confirm New Password   e.g Shubham@123"
                                                    value={resetPasswordForm?.confirmPassword || ""}
                                                    name="confirmPassword"
                                                    id="confirmPassword"
                                                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=^[^@$!%*?&]*[@$!%*?&][^@$!%*?&]*$)[A-Za-z\d@$!%*?&]{8,16}$"
                                                    autoComplete="false"
                                                    title="Please Enter The valid Password"
                                                    onChange={handleChange}
                                                />
                                                {inputValidationErrors && inputValidationErrors.confirmPassword && (
                                                    <div className="invalid-data">{inputValidationErrors.confirmPassword}</div>
                                                )}
                                            </div>

                                            <div className="input-box mb--20">
                                                <input type="checkbox" id="show-password" onClick={toggle_password} />
                                                <label htmlFor="show-password">Show Password</label>
                                            </div>

                                            <button
                                                className={"rn-btn edu-btn w-100"}
                                                type="button"
                                                onClick={handleResetPassForm}
                                            >
                                                <span>Continue</span>
                                                <i className="icon-arrow-right-line-right"></i>
                                            </button>

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};
export default ResetPasswordForm;
